import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    try {
      const response = await axios.post('https://filesapi.infomanav.in/api/aws/login-user', {
        email,
        password
      });

      const { accessToken, userData } = response.data;

      if (accessToken) {
        localStorage.setItem('token', accessToken); // Save token
        localStorage.setItem('userData', JSON.stringify(userData)); // Optional: Save user info
        navigate('/dashboard'); // Redirect to dashboard
      } else {
        alert('Login failed: Token not found in response');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('Login failed. Please check your credentials and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="login-card p-4 shadow rounded" style={{ width: '350px', backgroundColor: '#fff' }}>
        <h3 className="mb-4 text-center">Admin Login</h3>
        <input
          type="text"
          placeholder="email"
          className="form-control mb-2"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          className="form-control mb-3"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="btn btn-primary w-100" onClick={handleLogin} disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </div>
    </div>
  );
};

export default Login;
